export const appHead = {"meta":[{"charset":"utf-8"},{"hid":"description","name":"description","content":""},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1.0, viewport-fit=cover"}],"link":[{"rel":"preconnect","href":"https://fonts.gstatic.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.googleapis.com","crossorigin":""},{"rel":"preload","as":"style","href":"https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,500;1,300;1,500&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,500;1,300;1,500&display=swap"}],"style":[{"key":"css-variables","children":":root { --color-darkest:#22292A;--color-lightest:#FFFFFF;--color-primary:var(--color-brown);--color-primary-light:#6B5BD9;--color-primary-dark:#2D1F8F;--color-secondary:#BCD9D8;--color-secondary-light:#D8E8E7;--color-secondary-dark:#6E8C8B;--color-gray-100:#EEF2F5;--color-gray-200:#9797AA;--color-gray-300:#6B6B7F;--color-highlight-success:#1EAC70;--color-highlight-info:lightblue;--color-highlight-warning:orange;--color-highlight-error:#DF3755;--color-brown:#923C3B;--color-blue:#006789;--color-red:#BA4356;--color-green:#004F41;--color-beige:#FCFAE9;--color-mint:#E6F8F4;--color-sky:#E8F7FF;--color-peach:#FFEADE;--color-fog:#FFFEFC;--color-sand:#E4D7C8;--color-gold:#C7A353;--color-focus-ring:var(--color-brown);--color-slate:#22292A;--color-highlight-success:#64DCBF;--color-highlight-success-light:#cafff2;--color-highlight-error:#DC6464;--color-highlight-error-light:#ffd0d0;--color-highlight-info:#8897FF;--color-highlight-info-light:#e8f7ff;--transition-timing-slow:1s;--transition-timing-medium:500ms;--transition-timing-fast:150ms;--transition-timingFunction-in:cubic-bezier(0.4, 0, 1, 1);--transition-timingFunction-out:cubic-bezier(0, 0, 0.2, 1);--transition-timingFunction-in-out:cubic-bezier(0.4, 0, 0.2, 1);--transition-fast:var(--transition-timing-fast) 0ms var(--transition-timingFunction-in);--transition-medium:var(--transition-timing-medium) 0ms var(--transition-timingFunction-in);--transition-slow:var(--transition-timing-slow) 0ms var(--transition-timingFunction-in);--transition-page:opacity var(--transition-timing-fast) var(--transition-timingFunction-out);--transition-link:color var(--transition-fast);--spacing-2xs:.25rem;--spacing-xs:.5rem;--spacing-sm:.75rem;--spacing-md:1rem;--spacing-lg:1.5rem;--spacing-xl:2rem;--spacing-2xl:2.5rem;--spacing-3xl:3rem;--spacing-4xl:4.125rem;--grid-side-gap-xs:1.25rem;--grid-side-gap-sm:2rem;--grid-side-gap-md:3rem;--grid-side-gap-lg:4rem;--grid-side-gap-xl:5rem;--grid-side-gap-xxl:7.5rem;--grid-gap-xs:1.25rem;--grid-gap-sm:1.5rem;--grid-gap-md:2rem;--grid-gap-lg:2rem;--grid-gap-xl:2rem;--grid-gap-xxl:2.5rem;--grid-maxWidth-page:75rem;--grid-maxWidth-wideContent:62.25rem;--grid-maxWidth-content:50rem;--boxShadow-light:0px 0px 8px rgba(0, 0, 0, 0.06);--boxShadow-base:0px 0px 6px rgba(0, 0, 0, 0.16);--boxShadow-medium:0px 0px 11px rgba(0, 0, 0, 0.20);--boxShadow-heavy:0px 0px 40px rgba(0, 0, 0, 0.24);--boxShadow-outline:0px 0px 12px rgba(0, 0, 0, 0.24);--boxShadow-inset:inset 1px 1px 4px rgba(0, 0, 0, 0.12);--font-family-primary:Raleway, sans-serif;--font-family-secondary:Larken-Regular, serif;--font-size-xs:.75rem;--font-size-sm:.875rem;--font-size-md:1rem;--font-size-lg:1.125rem;--font-size-xl:1.25rem;--font-size-2xl:1.5rem;--font-size-3xl:2rem;--font-size-4xl:2.25rem;--font-size-5xl:2.5rem;--font-size-6xl:3rem;--font-size-7xl:5rem;--font-size-8xl:6.25rem;--font-weight-primary-hairline:300;--font-weight-primary-thin:300;--font-weight-primary-light:300;--font-weight-primary-normal:300;--font-weight-primary-medium:500;--font-weight-primary-semibold:500;--font-weight-primary-bold:500;--font-weight-primary-extrabold:500;--font-weight-primary-black:500;--font-weight-secondary-hairline:400;--font-weight-secondary-thin:400;--font-weight-secondary-light:400;--font-weight-secondary-normal:400;--font-weight-secondary-medium:400;--font-weight-secondary-semibold:400;--font-weight-secondary-bold:400;--font-weight-secondary-extrabold:400;--font-weight-secondary-black:400;--lineHeight-xs:.9;--lineHeight-sm:1;--lineHeight-md:1.2;--lineHeight-lg:1.4;--lineHeight-xl:2; }","type":"text/css"}],"script":[],"noscript":[],"title":"Hotelschool the Hague"}

export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appLayoutTransition = {"name":"fade","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false